import React, { FC, useState } from 'react';
import { SC } from '../../styles/theme';
import { AccessibleButton } from '@components/Button/AccessibleButton';
import Icon, { Icons } from '@components/Icon';
import Collapsible from 'react-collapsible';
import useTranslations from '@hooks/useTranslations';
import { DealerCommentProps } from '@components/DealerComment/index';
import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';
import Button from '@components/Button';
import UIDuck from '../../redux/commonDucks/ui.duck';
import { PERSONALIZE_OFFER_SECTIONS } from '@components/Modal/ModalPersonalizeOffer/ModalPersonalizeOfferTemplate';
import {isBrandAC, ModalVersion} from '../../constants/main';
import { useDispatch } from 'react-redux';
import { IconTemplate } from '@components/Icon/IconTemplate';
import { useUserDuck } from '@hooks/useUserDuck';
import { useGTM } from '@hooks/useGTM';

const DealerCommentTemplate: FC<DealerCommentProps> = ({ className, generatedIndex, withoutBorderTop }) => {
    const { t } = useTranslations();

    const { pushToDataLayer } = useGTM();

    const dispatch = useDispatch();

    const { currentDeal } = useCarDetailsDuck();
    const { isUserLoggedInAsDealer } = useUserDuck();

    const [isOpen, setIsOpen] = useState(true);

    return (
        <div data-testid="comment" className={className} id="comment">
            <Collapsible
                lazyRender={true}
                open={isOpen}
                trigger={
                    <AccessibleButton className="titleWrapperButton" onClick={() => setIsOpen(!isOpen)}>
                        <div className="titleWrapper">
                            {generatedIndex ? (
                                <div className="titleContainer">
                                    <span className="sectionNumber">{generatedIndex}.</span>
                                    <span className="title">{`${t('basket.comment.title').toLowerCase()}`}</span>
                                </div>
                            ) : (
                                <span className="title">{`${t('basket.comment.title')}`.toLowerCase()}</span>
                            )}
                            <Icon
                                className={isOpen ? 'isOpen' : 'isClose'}
                                name={isOpen ? Icons.ChevronUp : Icons.ChevronDown}
                            />
                        </div>
                    </AccessibleButton>
                }
            >
                <div className="wrapper">
                    {isUserLoggedInAsDealer && <p className="description">{t('basket.comment.description')}</p>}
                    {currentDeal?.extraFields?.comments?.[0] && (
                        <div className="section">
                            <span className="label">
                                {t(`basket.comment.label${isUserLoggedInAsDealer ? '.dealer' : ''}`)}
                            </span>
                            <p className="comment">{JSON.parse(currentDeal?.extraFields?.comments)?.[0]?.text}</p>
                        </div>
                    )}
                </div>
                {isUserLoggedInAsDealer && (
                    <Button
                        onClick={() => {
                            pushToDataLayer({
                                event: 'uaevent',
                                eventCategory: 'Content',
                                eventAction: 'Display::EditConfigurationModal',
                                eventLabel: t('modal.personalizeOffer.edit.button'),
                            });
                            dispatch(
                                UIDuck.openModal({
                                    data: {
                                        openSection: PERSONALIZE_OFFER_SECTIONS.COMMENT,
                                    },
                                    modalType: UIDuck.MODAL_TYPES.PERSONALIZE_OFFER,
                                    modalVersion: ModalVersion.v2,
                                    modalProperties: {
                                        withoutPadding: true,
                                    },
                                })
                            )
                        }}
                        secondary
                        hasEditIcon
                        fitContentWidth
                        withoutBackground={isBrandAC}
                        centerMode
                        marginTop={35}
                    >
                        <IconTemplate name={Icons.edit} />
                        {t('modal.personalizeOffer.edit.button')}
                    </Button>
                )}
            </Collapsible>
        </div>
    );
};

export default DealerCommentTemplate;
